import React from 'react'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import ListaProdutos from './components/listaProdutos'
import Login from './screens/login'
import Inicio from './screens/inicio'
import Cadastro from './screens/cadastro'
import Pedidos from './screens/pedidos'
import PainelFumigacao from './admin/painelfumigacao'
import Feeds from './admin/feeds'
import Seaports from './admin/seaports'
import Ships from './admin/ships'
import Employees from './admin/employees'
import Clients from './admin/clients'
import Services from './admin/services'
import News from './admin/news'
import Terminais from './admin/terminais'
import FumigationReport from './admin/fumigationreport'
import AddShip from './admin/addship'
import AddFeed from './admin/addfeed'
import AddSeaport from './admin/addseaport'
import AddEmployee from './admin/addemployee'
import AddClient from './admin/addclient'
import AddService from './admin/addservice'
import AddNews from './admin/addnews'
import AddTerminal from './admin/addterminal'
import ProdutoDetalhe from './components/produtoDetalhe'
import Carrinho from './components/carrinho'
import Upload from './components/upload'
import ClientSignin from './client/login'
import ClientInicio from './client/inicio'
import ShipStatus from './client/shipstatus'

import Configuracao from './admin/configuracao'
import OrdensServicos from './admin/ordensservicos'
import AddOrdemServico from './admin/addordemservico'
import Bens from './admin/bens'
import AddBem from './admin/addbem'
import OrdensSituacoes from './admin/ordenssituacoes'
import AddOrdemSituacao from './admin/addordemsituacao'
import AddPedido from './screens/addpedido'
import Vouchers from './screens/vouchers'
import AddVoucher from './screens/addvoucher'
import Usuarios from './screens/usuarios'
import AddUsuario from './screens/addusuario'
import Relatorios from './screens/relatorios'
import Programacao from './screens/programacao'
import AddProgramacao from './screens/addprogramacao'
import AdminRS from './screens/adminrs'
import Cobranca from './screens/cobranca'

export default function Routes(){

    const [url, setUrl] = React.useState('')


    React.useEffect(() => {
        
            let url_temporaria = window.location.pathname.split('/')[1];

            setUrl(url_temporaria)

    },[])



    return (
        <BrowserRouter >
            <Switch>
                <Route exact path="/" component={Login} />
                <Route path="/" exact component={Cadastro}  />
                <Route exact path="/pedidos" component={Pedidos} />
                <Route exact path="/vouchers" component={Vouchers} />
                <Route exact path="/usuarios" component={Usuarios} />
                <Route exact path="/relatorios" component={Relatorios} />
                <Route exact path="/programacao" component={Programacao} />
                <Route exact path="/adminrs" component={AdminRS} />

                <Route path="/addpedido/:id" component={AddPedido} />
                <Route path="/addvoucher/:id" component={AddVoucher} />
                <Route path="/addusuario/:id" component={AddUsuario} />
                <Route path="/addprogramacao/:id" component={AddProgramacao} />
                <Route path='/cobranca/:id' component={Cobranca} />

                <Route path="/admin/feeds/:id" component={Feeds} />
                <Route path="/admin/painelfumigacao" component={PainelFumigacao} />
                <Route path="/admin/seaports" component={Seaports} />
                <Route path="/admin/ships" component={Ships} />
                <Route path="/admin/configuracao" component={Configuracao} />
                <Route path="/admin/employees" component={Employees} />
                <Route path="/admin/clients" component={Clients} />
                <Route path="/admin/ordensservicos" component={OrdensServicos} />
                <Route path="/admin/bens" component={Bens} />
                <Route path="/admin/ordenssituacoes" component={OrdensSituacoes} />
                <Route path="/admin/services" component={Services} />
                <Route path="/admin/news" component={News} />
                <Route path="/admin/terminais" component={Terminais} />
                <Route path="/admin/fumigationreport/:id" component={FumigationReport} />

                <Route path="/admin/addship/:id" component={AddShip} />
                <Route path="/admin/addfeed/:id" component={AddFeed} />
                <Route path="/admin/addseaport/:id" component={AddSeaport} />
                <Route path="/admin/addemployee/:id" component={AddEmployee} />
                <Route path="/admin/addclient/:id" component={AddClient} />
                <Route path="/admin/addordemservico/:id" component={AddOrdemServico} />
                <Route path="/admin/addbem/:id" component={AddBem} />
                <Route path="/admin/addordemsituacao/:id" component={AddOrdemSituacao} />
                <Route path="/admin/addservice/:id" component={AddService} />
                <Route path="/admin/addnews/:id" component={AddNews} />
                <Route path="/admin/addterminal/:id" component={AddTerminal} />

                <Route path="/detalhes/:id" component={ProdutoDetalhe} />
                <Route path="/listaProdutos" component={ListaProdutos} />
                <Route path="/cadastro" component={Cadastro} />
                <Route path="/carrinho" component={Carrinho} />
                <Route path="/file/upload" component={Upload} />
                <Route path="/client/login" component={ClientSignin} />
                <Route path="/client/inicio" component={ClientInicio} />
                <Route path="/client/shipstatus/:id" component={ShipStatus} />                
            </Switch>
        </BrowserRouter>
    )
}